import { render, staticRenderFns } from "./order-success.vue?vue&type=template&id=26d63ebf&scoped=true&"
import script from "./order-success.vue?vue&type=script&lang=js&"
export * from "./order-success.vue?vue&type=script&lang=js&"
import style0 from "./order-success.vue?vue&type=style&index=0&id=26d63ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d63ebf",
  null
  
)

export default component.exports